<template>
  <div class="exchange">
    <router-view/>
  </div>
</template>

<script>
  export default {}
</script>

<style scoped>
.exchange {
  padding-top: 100px;
}
</style>



// WEBPACK FOOTER //
// src/vue/app/exchange/Exchange.Entry.vue